
(function() {
  var result = { translations: { "pt-br": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} m", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} m", "days": "{{ days }} dias", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ramal {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "pt-br": "static-7.1320"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1320",
    "ar-eg": "static-7.1320",
    "bg": "static-7.1320",
    "bn": "static-7.1320",
    "ca-es": "static-7.1320",
    "cs": "static-7.1320",
    "da": "static-7.1320",
    "de": "static-7.1320",
    "el": "static-7.1320",
    "en-gb": "static-7.1320",
    "en": "static-7.1320",
    "es-mx": "static-7.1320",
    "es": "static-7.1320",
    "et": "static-7.1320",
    "fi": "static-7.1320",
    "fr-ca": "static-7.1320",
    "fr": "static-7.1320",
    "he-il": "static-7.1320",
    "hi": "static-7.1320",
    "hr": "static-7.1320",
    "hu": "static-7.1320",
    "id": "static-7.1320",
    "it": "static-7.1320",
    "ja": "static-7.1320",
    "ko": "static-7.1320",
    "lt": "static-7.1320",
    "ms": "static-7.1320",
    "nl": "static-7.1320",
    "no": "static-7.1320",
    "pl": "static-7.1320",
    "pt-br": "static-7.1320",
    "pt-pt": "static-7.1320",
    "ro": "static-7.1320",
    "ru": "static-7.1320",
    "sk": "static-7.1320",
    "sl": "static-7.1320",
    "sv": "static-7.1320",
    "th": "static-7.1320",
    "tl": "static-7.1320",
    "tr": "static-7.1320",
    "uk": "static-7.1320",
    "vi": "static-7.1320",
    "x-pseudo": "static-7.1320",
    "zh-cn": "static-7.1320",
    "zh-hk": "static-7.1320",
    "zh-tw": "static-7.1320"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:pt-br', {version: 'static-7.1320'}); }
})();


